import React, { useState, useEffect } from "react";
import "./textInputStyle.scss";

const TextInputSecondary = ({ 
  label, 
  type = "text",  
  name, 
  value, 
  onChange, 
  placeholder, 
  required = false,
  isFieldChecked = false,
  requiredMsg = '',
  handleSecondaryCheck,
  secondaryCheckText = '',
  isSecondaryCheck = false,
  disabled = false
}) => {
  const [isActive, setIsActive] = useState(false);
  const [isTouched, setIsTouched] = useState(false);   
  const [isValid, setIsValid] = useState(true);  
  const [isChecked, setIsChecked] = useState(isFieldChecked);  // NEW STATE
  const [isSecondChecked, setIsSecondChecked] = useState(false)

  useEffect(() => {
    if (value) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [value]);

  const handleBlur = () => {
    setIsTouched(true);
    validateInput(value);  
  };

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailPattern.test(email);
  };

  const validateMobile = (mobile) => {
    const mobilePattern = /^[0-9]{10}$/;  
    return mobilePattern.test(mobile);
  };

  const validateInput = (inputValue) => {
    if (type === "email") {
      setIsValid(validateEmail(inputValue));
    } else if (type === "tel" || name.toLowerCase().includes("mobile")) {
      setIsValid(validateMobile(inputValue));
    }
  };

  const isError = (required && isTouched && !value) || (!isValid && isTouched);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleSecondCheckboxChange = () => {
    setIsSecondChecked(!isSecondChecked);
    handleSecondaryCheck(!isSecondChecked)
  };

  return (
    <div className={`SecInput form-group text-input ${isActive ? 'active' : ''}`}>
      <label htmlFor={name} className="form-label checkbox-label">
        <input
          className="form-check-input input-checkbox rounded-4"
          checked={isChecked}
          onChange={handleCheckboxChange}
          type="checkbox"
          id="flexCheckDefault"
        />
        <span className="label-text">
          {label} {required && <span className="required">*</span>}
        </span>

        {(isSecondaryCheck && isChecked) && <span className="secondary-check-text">
          <span className="second-checkbox-wrapper">
            <input
              className="form-check-input input-checkbox rounded-4"
              checked={isSecondChecked}
              onChange={handleSecondCheckboxChange}
              type="checkbox"
            />
          </span>
          {secondaryCheckText}</span>}
      </label>


      <input
        type={type}    
        className={`form-control ${isError ? 'error' : ''}`}  
        id={name}
        name={name}
        value={isChecked ? value : ""}  
        onChange={onChange} 
        placeholder={placeholder}
        required={required}
        onFocus={() => setIsActive(true)}   
        onBlur={() => { 
          setIsActive(false); 
          handleBlur(); 
        }}
        disabled={!isChecked || disabled} // disables until checkbox checked
      /> 

      {isError && (
        <small className="error-text">
          {!value
            ? requiredMsg ? requiredMsg : '' : ''}
        </small>
      )}
    </div>
  );
};

export default TextInputSecondary;
